import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=6eaf14a2&scoped=true"
var script = {}
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=6eaf14a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaf14a2",
  null
  
)

export default component.exports